const hasPermission = function (permissions, permissionType) {
    const number = parseInt(permissions, 10);
    const permission = (1 << permissionType);
    return ((number & permission) === permission);
};

export default hasPermission;
